import { render } from "./ServicioItem.vue?vue&type=template&id=4364f7f8&scoped=true"
import script from "./ServicioItem.vue?vue&type=script&lang=js"
export * from "./ServicioItem.vue?vue&type=script&lang=js"

import "./ServicioItem.vue?vue&type=style&index=0&id=4364f7f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4364f7f8"]])

export default __exports__